/*
 * Plugin jQuery que retorna o nome da bandeira do cartão
 * referente ao valor digitado no elemento passado no seletor
 * jQuery.
 *
 * returns: ['elo'|'visa'|'mastercard'|'amex'|'diners'|'hipercard'|null]
 * example: $('#id_element').getCreditCardFlag();
 *
 * @depends jquery.m4u.getFlagRegex.js
 */
(function ( $ ) {
  $.fn.getCreditCardFlag = function(ccFlagIdentifierRegExp) {
    var ccNumber = $(this).val();
    ccNumber = ccNumber.replace(/[^0-9]/g, '');
    if (ccNumber.length > 13) {
      for (var cardType in ccFlagIdentifierRegExp) {
        if (cardType != '' && ccFlagIdentifierRegExp.hasOwnProperty(cardType)) {
          var regex = ccFlagIdentifierRegExp[cardType];
          if (ccNumber.match(regex)) {
            return cardType.toLowerCase();
          }
        }
      }
    }
    return null;
  };
}(jQuery));



// WEBPACK FOOTER //
// ./src/js/vendor/jquery.cardflag.js